import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const StepSeparator: React.FC<IconSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none" {...props}>
    <path d="M68.5029 4.09998L4.09964 68.5033" stroke={props.color} strokeWidth="7" strokeLinecap="round" />
  </svg>
)
